var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 30 30" },
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0",
        y: "0",
        viewBox: "0 0 30 30",
        "xml:space": "preserve",
        "fill-rule": "evenodd",
      },
    },
    [
      _c("g", [
        _c("path", {
          attrs: {
            "fill-rule": "nonzero",
            d: "M4.937 15.852c.022-.471.71-.652.958-.253.052 4.099-.256 8.366-.1 12.49-.416.763-1.442-.053-1.058-.758a6.953 6.953 0 0 0-.031-.592c-.178-3.63.075-7.263.231-10.887",
            "fill-color": _vm.color,
            opacity: "1",
            "data-original": "#000000",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "nonzero",
            d: "M3.772 28.686c-.568.128-.861-.753-.329-.99.435-.166.925-.152 1.382-.217 7.388-.106 14.79-.381 22.172-.007.513.097 1.1.067 1.57.325.336.222.29.788-.08.952-8.167-.593-16.51-.44-24.715-.063",
            "fill-color": _vm.color,
            opacity: "1",
            "data-original": "#000000",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "nonzero",
            d: "M5.593 16.433c-.925.026-.568-1.406.29-1.085.236-.02.473-.041.71-.064 1.169-.01 2.678-.66 3.573.38.166.262.288.556.344.863.117 3.54.106 7.153-.08 10.67-.358.617-1.282.068-1.037-.57v-.387l.001-.619c-.086-3.116.417-6.324-.092-9.389-1.165-.255-2.49.21-3.71.201M12.983 10.502c.118-.81 1.378-.374 1.016.358l-.071.486a4.738 4.738 0 0 0-.02.56c.078.716.169 1.434.207 2.155.645 3.649.547 7.374.456 11.064l.001 1.687.001.423c.344.644-.502 1.504-1.008.86-.411-4.476.434-9.134-.475-13.61a84.143 84.143 0 0 0-.238-2.57c-.025-.475.071-.944.131-1.413",
            "fill-color": _vm.color,
            opacity: "1",
            "data-original": "#000000",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "nonzero",
            d: "M13.65 11.526c-.873.07-.655-1.321.182-1.083.224-.03.45-.042.675-.05.297-.011.593-.004.89-.006 1.335.273 3.115-.591 4.138.517.206.323.27.711.293 1.087-.56 5.245-.264 10.541-.466 15.801-.27.723-1.35.216-1.08-.482v-.387l.002-.619V25.18c.206-4.272-.127-8.566.49-12.815.072-.32-.102-.727-.069-1.001-1.674.222-3.379-.054-5.055.162M9.34 26.517c.13-.932 1.49-.316 1.029.488-.016.249-.028.498-.034.749-.048.303.088.648-.065.935-.431.723-1.412-.076-1.04-.76.006-.24.022-.477.043-.715l.066-.697M22.126 7.133c.118-.848 1.413-.362 1.018.394l-.074.63c-.032.273-.064.547-.094.82a27.42 27.42 0 0 0-.103 1.139c-.252 5.591.237 11.237-.193 16.803a.47.47 0 0 1-.489.2c-1.148-.933 1.484-.951.619.156-.193.226-.245.795-.642.708-.331-.383-.422-.923-.498-1.41.326-6.478-.35-12.989.456-19.44",
            "fill-color": _vm.color,
            opacity: "1",
            "data-original": "#000000",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "nonzero",
            d: "M22.445 7.215c-.91.039-.592-1.385.262-1.087a10.157 10.157 0 0 1 1.195-.054c1.243.227 2.994-.557 3.844.654.224.427.222.924.237 1.393-.473 6.542.256 13.127-.094 19.649-.355.683-1.348.07-1.055-.604v-.456c-.033-.92.134-1.831.086-2.75-.26-5.606-.165-11.277-.047-16.855-1.474.088-2.958-.06-4.428.11M7.622 13.609c.11.576-.79.836-1.004.289-.38-2.055.36-4.27 1.73-5.827 3.112-3.155 7.987-4.348 12.288-3.512.793.728.022 1.738-.623 2.241-.106.102-.216.198-.326.296-.598.735-1.523-.503-.664-.902.153-.137.305-.276.453-.418.267-.09.47-.957.707-.429.108.137-.026.259-.167.207-5.171-.863-12.92 1.712-12.394 8.055",
            "fill-color": _vm.color,
            opacity: "1",
            "data-original": "#000000",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "nonzero",
            d: "M20.127 4.26c.65.63-.585 1.375-.966.567-.17-.145-.34-.288-.514-.426-.211-.224-.564-.337-.695-.636-.295-.784.938-1.055 1.241-.338.108.09.215.183.32.276.208.182.41.372.614.557M8.764 16.344c.23-.247.386.308.08.38l-.171.278c-.384.266-.361 1.057-.82 1.217-.61-.44.945-1.356.91-1.875M9.568 16.26c.051-.128.262-.078.251.059-.23.587-.54 1.158-.858 1.704-.137.228-.274.458-.408.687l-.227.383c-.042.592-.744.17-.239-.143l.228-.382c.174-.293.35-.585.527-.875.282-.457.49-.953.726-1.433M9.502 17.957c.293-.244.341.447 0 .452l-.09.145c-.07.117-.136.238-.199.36-.18.37-.376.733-.585 1.089-.106.18-.213.362-.321.542-.077.127-.154.252-.233.376-.004.58-.756.272-.292-.06.068-.105.136-.213.202-.319.18-.295.357-.594.533-.893.333-.561.575-1.179.985-1.692M9.184 20.074c.28-.283.386.467.028.484-.426.572-.709 1.39-1.287 1.83-.645-.304.963-1.13.796-1.52l.128-.214a37.479 37.479 0 0 0 .334-.58M9.85 22.137c-.64.815-1.198 1.704-1.921 2.449-.351.36.527-.858.79-1.287.262-.43.438-.926.79-1.288.084-.086.226.083.34.126",
            "fill-color": _vm.color,
            opacity: "1",
            "data-original": "#000000",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "nonzero",
            d: "M9.365 21.93c.06-.122.267-.06.247.077-.438.85-1.013 1.64-1.576 2.415.105.231-.433.688-.455.284.498-.974 1.286-1.79 1.784-2.775",
            "fill-color": _vm.color,
            opacity: "1",
            "data-original": "#000000",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "nonzero",
            d: "M9.817 21.905c.202-.254.402.254.113.353-.428.712-.872 1.492-1.454 2.082-.335.037-.103-.508.083-.529.46-.606.927-1.216 1.258-1.906M9.708 24.687c.356-.208.236.54-.08.501-.14.241-.274.483-.425.715a4.755 4.755 0 0 1-.27.39c-.122.627-.8.092-.22-.168.092-.119.177-.244.26-.37.247-.355.412-.77.735-1.068M17.724 10.892c.231-.237.379.312.07.375l-.1.154c-.067.105-.133.21-.197.316-.201.345-.403.69-.632 1.017-.095.142-.187.284-.275.43.038.559-.721.323-.302-.031.074-.133.155-.261.238-.388.149-.226.306-.444.447-.675.24-.406.487-.807.751-1.198M18.67 11.397c.848-.19-.747 1.606-.724 1.7a20.3 20.3 0 0 0-.454.734c-.142.236-.27.479-.408.716-.067.112-.133.225-.202.335-.056.696-.846.195-.238-.145.114-.18.22-.364.326-.55.279-.51.594-1 .909-1.488.27-.43.529-.867.79-1.302M18.498 13.707c.685-.245-.331 1.296-.442 1.197-.224.346-.456.687-.679 1.035-.111.173-.22.348-.325.526-.076.73-.838.092-.178-.246.089-.145.178-.288.27-.43.167-.254.336-.506.505-.756.294-.436.572-.88.849-1.326",
            "fill-color": _vm.color,
            opacity: "1",
            "data-original": "#000000",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "nonzero",
            d: "M18.906 13.737c.057-.139.286-.065.248.081-.64 1.422-1.603 2.672-2.555 3.898-.859.027.909-1.375.866-1.587.51-.779 1.073-1.532 1.44-2.392",
            "fill-color": _vm.color,
            opacity: "1",
            "data-original": "#000000",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "nonzero",
            d: "M17.968 15.978c.05-.14.281-.079.253.068-.559 1.302-1.369 2.497-2.223 3.624-.765.018.684-1.177.64-1.359.456-.769 1.012-1.49 1.33-2.333M19.32 18.53c.055-.121.255-.07.247.061-.56 1.253-1.36 2.395-2.197 3.48.103.132-.546 1.145-.642.582.777-1.426 1.942-2.615 2.592-4.124M18.064 19.562c.066-.115.262-.048.243.083a45.208 45.208 0 0 1-1.983 3.014c-.389.104-.12-.604.085-.607a68.884 68.884 0 0 0 1.655-2.49M18.115 22.23c.065-.104.243-.052.24.07-.585 1.01-1.401 1.921-2.111 2.855-.686.002.53-1.032.543-1.138.456-.585.907-1.176 1.328-1.787M18.624 23.673c1.034-.149-1.208 2.19-1.433 2.41-.378.016-.017-.586.167-.571.47-.577.96-1.156 1.266-1.84",
            "fill-color": _vm.color,
            opacity: "1",
            "data-original": "#000000",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "nonzero",
            d: "M17.35 25.375c.234-.237.379.316.07.378l-.1.154c-.326.273-.393.943-.82 1.079-.578-.395.923-1.152.85-1.611M26.416 6.838c.67-.188-.366 1.067-.414 1.097-.254.404-.555.775-.816 1.175-.092.14-.183.28-.271.422-.034.832-.957.275-.236-.148.126-.198.253-.395.386-.588.155-.228.326-.446.485-.67.293-.428.56-.87.866-1.288M27.217 7.598c.052-.124.256-.078.251.055-.658 1.564-1.772 2.886-2.76 4.249-.271.165-.311-.37-.038-.416.471-.656.975-1.287 1.438-1.95.413-.619.785-1.268 1.109-1.938M27.013 10.44c.205-.232.39.256.099.341l-.124.201c-.647.97-1.258 2.029-2.048 2.884-.455-.002.121-.728.237-.735.68-.849 1.264-1.768 1.836-2.69",
            "fill-color": _vm.color,
            opacity: "1",
            "data-original": "#000000",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "nonzero",
            d: "M26.427 11.933c.074-.115.27-.029.235.104-.905 1.136-1.65 2.413-2.566 3.54-.514.072.116-.82.264-.775a44.425 44.425 0 0 1 2.067-2.87M27.17 13.58c.74-.14-.565 1.216-.579 1.256-.256.388-.527.769-.795 1.15-.164.23-.324.463-.49.691a5.913 5.913 0 0 1-.254.328c-.113.417-.604.02-.219-.175.055-.063.106-.13.157-.195.106-.138.207-.28.307-.422.205-.29.41-.578.616-.866.419-.59.8-1.207 1.258-1.768",
            "fill-color": _vm.color,
            opacity: "1",
            "data-original": "#000000",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "nonzero",
            d: "M26.825 13.546c.066-.134.287-.045.242.098-.646 1.298-1.55 2.444-2.392 3.611-.877-.138 1.16-1.56 1.025-1.865.414-.59.774-1.215 1.125-1.844M26.742 15.456c.066-.147.305-.04.24.107-.756 1.415-1.846 2.62-2.717 3.958-.447.112-.05-.7.135-.694.782-1.122 1.696-2.16 2.342-3.371M26.196 18.108c.062-.123.27-.057.247.08-.682 1.367-1.6 2.603-2.541 3.803-.901-.04 1.099-1.51 1.006-1.783.476-.67.884-1.385 1.288-2.1M27.122 20.003c.624-.208-.222 1.05-.392.984-.235.31-.47.624-.709.933-.154.202-.314.4-.476.597-.081.726-.944.254-.299-.076a32.34 32.34 0 0 0 .872-1.096c.342-.443.683-.886 1.004-1.342M26.64 22.074c.069-.12.273-.043.242.093-.646 1.053-1.473 2.01-2.214 2.992-.471.056.045-.73.207-.731.609-.768 1.231-1.53 1.766-2.354M27.12 22.473c.068-.116.266-.042.24.09-.619 1.047-1.369 2.039-2.053 3.04-.485.068.045-.757.195-.782.586-.75 1.092-1.557 1.619-2.348M27.164 23.778c.718-.183-.464 1.254-.543 1.218-.274.377-.545.756-.818 1.133-.113.158-.235.31-.347.467.06.579-.767.42-.342.013a3.26 3.26 0 0 1 .183-.268c.135-.177.268-.357.4-.537l.554-.758c.309-.42.612-.843.913-1.268M27.042 25.25c.27-.22.34.38.02.402a3.227 3.227 0 0 0-.158.239c-.15.26-.276.533-.436.788-.052.089-.104.178-.152.271.026.452-.608.26-.29-.05a5.81 5.81 0 0 1 .146-.263c.085-.144.174-.286.253-.434.174-.337.368-.665.617-.953",
            "fill-color": _vm.color,
            opacity: "1",
            "data-original": "#000000",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }